module.exports = __webpack_public_path__ + "img/friend_icon.b44982e4.png";